<template>
  <div id="swiper-wrap" data-aos="fade-up" data-aos-duration="1000">
    <div class="slider-wrap">
      <div class="slider-container">
        <div class="item slide tns-item">
          <div class="img-wrap">
            <img src="../../assets/images/02_2x.jpg" />
          </div>
        </div>
        <div class="item slide tns-item">
          <div class="img-wrap">
            <img src="../../assets/images/03_2x.jpg" />
          </div>
        </div>
        <div class="item slide tns-item">
          <div class="img-wrap">
            <img src="../../assets/images/04_2x.jpg" />
          </div>
        </div>
        <div class="item slide tns-item">
          <div class="img-wrap">
            <img src="../../assets/images/05_2x.jpg" />
          </div>
        </div>
        <div class="item slide tns-item">
          <div class="img-wrap">
            <img src="../../assets/images/06_2x.jpg" />
          </div>
        </div>
        <div class="item slide tns-item">
          <div class="img-wrap">
            <img src="../../assets/images/slider-fabbrica.jpg" />
          </div>
        </div>
        <div class="item slide tns-item">
          <div class="img-wrap">
            <img src="../../assets/images/slider-lab.jpg" />
          </div>
        </div>
      </div>
      <div class="slider-arrows-wrap">
        <div class="prev slider-arrow">
          <img
            src="../../assets/images/arrow-slide-prev@2x.png"
            data-over="cta"
          />
        </div>
        <div class="next slider-arrow">
          <img
            src="../../assets/images/arrow-slide-next@2x.png"
            data-over="cta"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tns } from "tiny-slider/src/tiny-slider";

export default {
  name: "SliderCarousel",
  props: ["lang"],
  data() {
    return {
      swiperEL: null,
    };
  },
  methods: {
    createSwiper() {
      this.swiperEL = tns({
        container: ".slider-container",
        items: 2,
        slideBy: 1,
        autoplay: false,
        controlsContainer: ".slider-arrows-wrap",
        mouseDrag: true,
        gutter: 10,
        loop: true,
        nav: false,
        responsive: {
          900: {
            items: 4,
          },
        },
      });
    },
  },
  mounted() {
    this.createSwiper();
  },
  beforeDestroy() {
    this.swiperEL.destroy();
  },
  watch: {
    lang(laang) {},
  },
};
</script>

<style lang="scss" scoped>
.slider-wrap {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.slider-container {
  position: relative;
  cursor: grab;
  margin-left: -13%;
  margin-right: -13%;
  @media screen and (max-width: 900px) {
    margin-left: -26%;
    margin-right: -26%;
  }
}
.img-wrap {
  position: relative;
  width: 100%;
  img {
    display: block;
    width: 100%;
  }
}
.slider-arrows-wrap {
  position: relative;
  width: 100%;
  text-align: center;
  display: flex;
  align-content: center;
  justify-content: center;
  margin: 60px auto 100px;
  outline: transparent;
  @media screen and (max-width: 900px) {
    margin: 60px auto 50px;
  }
  .slider-arrow {
    display: block;
    width: 25px;
    outline: transparent;
    margin: 0 10px;
    cursor: pointer;
    img {
      display: block;
      width: 100%;
      outline: transparent;
    }
  }
}
</style>


// WEBPACK FOOTER //
// SliderCarousel.vue?3dabc059